module.exports = __webpack_public_path__ + "static/media/logo_header.8937ccd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_header.svg
// module id = 129
// module chunks = 3